import { generatePath, useLoaderData, useLocation } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { ModelType } from '../../../../../common/enums.js';
import { omaElisaForCompaniesMsg, t, voiceSubscriptionsMsg } from '../../../../../common/i18n';
import { AnalyticsEventOrigins } from '../../../../../common/utils/analyticsUtils';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { OrderSubscriptionSelection } from '../../../../../components/OrderSubscriptionSelection/OrderSubscriptionSelection.js';
import type { SubscriptionUpdateLoaderData } from '../../../../../common/loaders';

export const MobileSubUpdatePath = () => {
  const { search } = useLocation();
  const { addOnRules, companyInfo, onlineModels, subscription } = useLoaderData() as SubscriptionUpdateLoaderData;
  const visibleOffers = companyInfo?.uiOptions?.visibleOffers;

  return (
    <>
      <BreadCrumbsWithTitle
        breadCrumbPaths={[
          { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
          { name: t.AR0B(voiceSubscriptionsMsg), path: paths.PS_MOBILE_SUBSCRIPTIONS },
          {
            name: getSubscriptionBreadcrumbName(subscription),
            path:
              generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) +
              search,
          },
          { name: t.MGWG('Subscription update') },
        ]}
      />
      <OrderSubscriptionSelection
        addOnRules={addOnRules}
        isChangeOffer={true}
        showOnlyMinuteAndLegacy={false}
        onlineModels={onlineModels}
        onlineModelType={ModelType.YrityspuheUusi}
        subscription={subscription}
        visibleOffers={visibleOffers}
        hideYrityspuheUUSI={companyInfo?.hideYrityspuheUUSI}
        eventOrigin={AnalyticsEventOrigins.OMAELISA}
      />
    </>
  );
};
